<div class="product-info-section">
  <div class="product-info-title">{{ title }}</div>
  <div class="product-info" [style.-webkit-line-clamp]="productInfoClampTo">{{ productInfo }}</div>
</div>
